/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomLocalizationTarget } from '../../models/custom-localization-target';
import { LocalizationRestoreRequestDto } from '../../models/localization-restore-request-dto';

export interface RestoreLocalizations$Params {
  type: CustomLocalizationTarget;
  'X-API-Version'?: string;
      body: LocalizationRestoreRequestDto
}

export function restoreLocalizations(http: HttpClient, rootUrl: string, params: RestoreLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, restoreLocalizations.PATH, 'put');
  if (params) {
    rb.path('type', params.type, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

restoreLocalizations.PATH = '/api/localizations/{type}/backup';
